/** Cache keys for a workspace's AI models (spec 215). */
export const aiModelsKeys = {
  all: ['ai-models'] as const,
  /** One workspace's period, cached per period as the Usage page caches its own. */
  workspace: (workspaceId: string, period: string | undefined) =>
    ['ai-models', 'workspace', workspaceId, period ?? 'current'] as const,
};
